import { Component, OnInit, ViewEncapsulation,
    Input, ViewChild, ElementRef, EventEmitter, Output, Renderer } from '@angular/core';

import { NoteModel, RiderNotesModel } from '../rider-notes.model';
import { RiderNotesService } from '../rider-notes.service';

@Component({
  selector: 'app-riders-add-rider-note',
  templateUrl: './add-rider-note.component.html',
  styleUrls: ['./add-rider-note.component.scss']
})
export class AddRiderNoteComponent implements OnInit {

    @Input() riderid: number;
    @Input() noteid: number;
    @Output() closeForm: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() closeAfterSave: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('btnSave') btnSave;

    public data: RiderNotesModel = <RiderNotesModel>{};
    public note: NoteModel= <NoteModel>{};
    public items= [];
    public itemsComplain= [];
    public itemStatus= [];
    public itemUsers= [];
    public showComplaint= true;
    public showComplaint2= false;

    public showSpeedNote= false;
    public speedCode: string;

  constructor(protected service: RiderNotesService, private renderer: Renderer, elementRef: ElementRef) { }

  ngOnInit() {
      this.data.riderid = this.riderid;
      if (this.noteid !== undefined) {
          this.service.getRiderNote(this.noteid).subscribe(
              data => {
                  this.loadData(data);
              }
          );
      }
  }

    public saveTripNote() {

        this.renderer.setElementProperty(this.btnSave.nativeElement, 'disabled', true);
        this.data.moduleid = 36;
        this.data.note = this.note;
        if (this.noteid === undefined) {
            this.service.postRiderNote(this.data).subscribe(
                data => {
                    this.returnSave(data);
                }
            );
        }else {

            this.service.putRiderNote(this.data).subscribe(
                data => {
                    this.returnSave(data);
                }
            );

        }
    }

    public loadData(data) {
        this.note.noteid        = data.note.noteid;
        this.note.description   = data.note.description;
    }

    public returnSave(data) {
        this.closeAfterSave.emit(data);
    }

    public getTypeNote() {

    }
    public closeWindow() {
        this.closeForm.emit(true);
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/riders/rider-notes/add-rider-note/add-rider-note.component.ts